import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class Slider {
    constructor(target, option) {
        this.target = target;
        this.option = option;
        this.swiperInstance;
        this.init();
    }

    init() {
        const swiper = new Swiper(this.target, this.option);
        this.swiperInstance = swiper;
    }
}
